export const bussiness = [
    { book: 'Think and Grow Rich - Suy nghĩ và làm giàu', author: '(Napoleon Hills)' },
    { book: 'Người giàu nhất thành Babylon ', author: '(George Clason)' },
    { book: 'Bí quyết gây dựng cơ nghiệp bạc Tỷ ', author: '(Adam Khoo)' },
    { book: 'Bí mật tư duy triệu phú ', author: '(T. Harv Eker)' },
    { book: 'Thế giới phẳng ', author: '(Thomas L. Friedman)' },
    { book: 'Cú Hích ', author: '(Richard Thaler, Cass Sunstein)' },
    { book: 'Dám nghĩ lớn – The Magic Of Thinking BIG', author: ' (David Schwartz)' },
    { book: 'Hẹn bạn trên đỉnh thành công ', author: '(Zig Zig Lar)' },
    { book: 'Làm giàu một cách khoa học ', author: '(Wallace D. Wattles)' },
    { book: ' Làm chủ tư duy, thay đổi vận mệnh ', author: '(Adam Khoo)' },
    { book: ' Những mẩu chuyện hài hước trong kinh doanh của người Do Thái', author: '' },
    { book: 'Trí tuệ kinh doanh và lý thuyết trò chơi', author: '' },
    { book: 'Binh pháp Tôn Tử và nghệ thuật kiếm tiền **', author: '' },
    { book: 'Những nguyên tắc cơ bản của việc kinh doanh **', author: '' },
    { book: '48 nguyên tắc chủ chốt của quyền lực **', author: '(Robert Greene) ' },
    { book: 'Tư duy đột phát – Breakthrough Thinking', author: ' (Gerald Nadler, Shozo Hibino)' },
    { book: 'Dám thất bại – Dare to Fail **', author: '(Billi P. S. Lim) ' },
    { book: ' Tiền không phải là vấn đề  **', author: '(Bob Proctor)' },
]
export const final = [
    { book: ' Sách lược đầu tư của Warren Buffet ', author: '(Lý Thành Tư)' },
    { book: 'Nhà đầu tư thông minh ', author: '(Ben Graham)' },
    { book: 'Thịnh vượng tài chính tuổi 30', author: '' },
    { book: 'Tư duy như những nhà Đầu tư vĩ đại ', author: '(Colin Nicholson)' },
    { book: 'Cổ phiếu thường lợi nhuận phi thường ', author: '(Philip A. Fisher)' },
    { book: 'Bí mật của vua Solomon ', author: '(Bruce Fleet)' },
    { book: 'Dạy con làm giàu tập 1 - Để Không Có Tiền Vẫn Tạo Ra Tiền', author: '' },
    { book: ' Dạy con làm giàu tập 2 - Sử Dụng Đồng Vốn', author: '(Robert T. Kiyosaki)' },
    { book: ' Dạy con làm giàu tập 3 - Hướng Dẫn Đầu Tư ', author: '(Robert T. Kiyosaki)' },
    { book: ' Dạy con làm giàu tập 4 - Con Giàu Con Thông Minh ', author: '(Robert T. Kiyosaki)' },
    { book: 'Dạy con làm giàu tập 5 - Để Có Sức Mạnh Về Tài Chính‎ ', author: '(Robert T. Kiyosaki)' },
    { book: ' Dạy con làm giàu tập 6 - Những câu chuyện thành công', author: '(Robert T. Kiyosaki)' },
    { book: 'Dạy con làm giàu tập 7 - Ai đã lấy tiền của tôi', author: '(Robert T. Kiyosaki)' },
    { book: ' Dạy con làm giàu tập 8 - Để Có Những Đồng Tiền Tích Cực', author: '(Robert T. Kiyosaki)' },
    { book: '  Dạy con làm giàu tập 9 - Những Bí Mật Về Tiền Bạc', author: '(Robert T. Kiyosaki)' },
    { book: ' Dạy con làm giàu tập 10 - Trước Khi Bạn Thôi Việc', author: '(Robert T. Kiyosaki)' },
    { book: 'Dạy con làm giàu tập 11 - Trường dạy kinh doanh ', author: '(Robert T. Kiyosaki)' },
    { book: 'Đừng bận tâm về chuyện tiền bạc  ', author: ' (Richard Carlson)' },
    { book: ' Nghệ thuật quản lý tiền và tài sản của người Do Thái ** ', author: '' },

]

export const marheting = [
    { book: ' Nghệ thuật bán hàng bậc cao', author: '(Zig Zig Lar)' },
    { book: '22 Quy luật bất biến trong Marketing ', author: '(Al Ries & Jack Trout)' },
    { book: 'Người bán hàng vĩ đại nhất thế giới', author: '(OG Mandino)' },
    { book: ' 100 ý tưởng tiếp thị tuyệt hay', author: ' (Jim Blythe)' },
    { book: ' Cỗ máy bán hàng tối ưu (Chet Holmes) **', author: '' },
    { book: 'Nâng tầm dịch vụ (Ron Kaufman) **', author: '' },
    { book: '1001 ý tưởng quảng cáo đột phát  **', author: '(Dupoint)' },
    { book: 'Nghệ thuật bán hàng – giải mã thành công  **', author: '(Phạm Cao Tùng)' },
]

export const manager = [
    { book: ' Tuần làm việc 4 giờ', author: '(Tim Ferris) ' },
    { book: 'Từ tốt đến vĩ đại ', author: '  (Jim Collins)' },
    { book: '  Đọc vị bất kỳ ai ', author: ' (Davis)' },
    { book: ' Con người 80/20 – 9 yếu tố cốt lõi của lãnh đạo thành công ', author: ' (Richard Koch)' },
    { book: '  Đừng bao giờ đi ăn một mình ', author: '(Keith Ferrazzi) ' },
    { book: ' Mỗi ngày tiết kiệm 1 giờ ', author: ' (Michael Heppell)' },
    { book: ' Tứ thư lãnh đạo – thuật xử thế ', author: '(Hoà Nhân) ' },
    { book: 'Thương gia Do Thái – bậc thầy kinh doanh  ', author: ' (Trương Đổng Triết)' },
    { book: '  Góc nhìn người của người thông thái **', author: ' ' },
    { book: ' Nghiên cứu phong cách lãnh đạo của các doanh nhân Nhật Bản **', author: ' ' },
    { book: 'Nhà quản lý tài năng (Noriyuki Sasaki) ** ', author: ' ' },
    { book: '  Bí mật trị vì vương quốc đến quản lý công ty ', author: '(Seldon Bowles) ' },
    { book: ' Biết người, dùng người, quản người ', author: ' (Tạ Ngọc Ái)' },
]

export const advanceBussiness = [
    {book:' Mặc kệ nó, làm tới đi  ', author:' (Richard Branson)'},
    {book:' Những nguyên tắc thành công ', author:'(Jack Canfield) '},
    {book:'Tam quốc diễn nghĩa @  ', author:' (Thành Quân Ức)'},
    {book:' C​​ách sống từ bình thường trở nên phi thường', author:' (Inamori Kazuo) '},
    {book:'  Đánh thức con người phi thường trong bạn ', author:'(Tony Robbins) '},
    {book:' 80 chiêu thức thành công trong kinh doanh ', author:' (Vương Chí Cương) '},
    {book:'100 quy luật bất biến để thành công trong kinh doanh  ', author:'(Brian Tracy) '},
    {book:'  999 bí quyết vàng trong kinh doanh', author:' '},
    {book:'  Dám làm giàu', author:'  (Phạm Tuấn Sơn)'},
    {book:'Thành công không còn là bí mật ', author:' (Noah St. Jonhson)'},
    {book:'  Kinh doanh bằng tâm lý ', author:'(Brian Tracy) '},
    {book:'101 Trí Tuệ người Do Thái  ** ', author:' (Đàm Đức)'},
    {book:' 9 loại người bạn cần phòng tránh  **', author:'(Trương Lăng Tùng) '},
    {book:'  Chi tiết quyết định sự thành bại  **', author:' (Uông Trung Cầu)'},
    {book:'Vị giám đốc 1 phút  ** ', author:'(Ken Blanchard) '},
    {book:'11 lời khuyên dành cho thế hệ trẻ của Bill Gates ** ', author:' '}
]

export const emotion = [
    {book:' Tứ đại quyền lực  ', author: ' (Scott Galloway)'},
    {book:'Quốc gia khởi nghiệp ', author: '  (Dan Senor, Saul Singer)'},
    {book:' Sách đen về tinh thần doanh nhân ', author: ' (Fernando Trías De Bes)'},
    {book:'  Bạch Thái Bưởi – khẳng định doanh tài nước Việt **', author: ' '},
    {book:'Henry Ford – đặt thế giới lên 4 bánh xe ', author: ' '},
    {book:'Bí mật của may mắn ', author: ' '},
    {book:'Steve Jobs – Sức mạnh của sự khác biệt ** ', author: ' '},
  
]
